/* create by ma.rongqin 2016.11.29 */
'use strict';
angular.module('manageSysManageCategoryRelationModule', ['manageSysCategoryRelationServiceModule','categoryRelationDirectiveModule'])
    .controller('manageSysManageCategoryRelationCtrl', ['$scope', '$filter', '$q', 'manageSysCategoryRelationService', 'trsHttpService', 'trsspliceString',
        function($scope, $filter, $q, manageSysCategoryRelationService, trsHttpService, trsspliceString) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             */
            function initStatus() {
                $scope.categoryParams = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'queryCategorysWithOutRight',
                    IsCore: 'true',
                };
                $scope.data = {
                    categoryItems: [],
                    relationItems: {},
                };
                $scope.status = {
                    openBoolen:"",
                    elmHeight:0,
                    listBoolen:false
                }
            }
            /**
             * [initData description] 初始化数据
             */
            function initData() {
                getCategory().then(function(data) {
                    var ids = "";
                    angular.forEach(data, function(value, key) {
                        if (ids.length > 0 && value.CHILDLIST.length > 0) ids += ',';
                        ids += trsspliceString.spliceString(value.CHILDLIST, 'ID', ',');
                    });
                    getRelationCategory(ids);
                })
            }
            /**
             * [initAll description] 初始化
             */
            $scope.initAll = function(){
                initData()
            }
            /**
             * [openTable description] 点击打开收起
             */
             $scope.openTable = function(obj){
                console.log(obj);
             }
            /**
             * [getCategory description] 获取大分类
             */
            function getCategory() {
                var defer = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.categoryParams, "get")
                    .then(function(data) {
                        console.log(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].CHILDLIST = data[i].CHILDLIST || [];
                        }
                        $scope.data.categoryItems = data;
                        defer.resolve(data);
                    });
                return defer.promise;
            };
            /**
             * [getRelationCategory description] 获取已关联稿库类别
             */
            function getRelationCategory(ids) {
                var params = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'queryCoreAndNotCoreCategoryRelsByCatgory',
                    CoreIds: ids
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                    .then(function(data) {
                        angular.forEach(data, function(value, key) {
                            if (!angular.isArray($scope.data.relationItems[value.CORECATID])) $scope.data.relationItems[value.CORECATID] = [];
                            $scope.data.relationItems[value.CORECATID].push(value);
                            $scope.data.relationItems[value.CORECATID] = $filter('unique')($scope.data.relationItems[value.CORECATID], 'CORECATEGORYRELID');
                        });
                    });
            };
            /**
             * [modifyCategoryRelation description] 编辑弹窗
             */
            $scope.modifyCategoryRelation = function(item) {
                // var items = trsspliceString.spliceString($scope.data.relationItems[item.ID], 'CATID', ',');
                var items = $scope.data.relationItems[item.ID];
                manageSysCategoryRelationService.categoryRelationModify(items, function(result) {
                    var params = {
                        serviceid: 'mlf_sharedoc',
                        methodname: 'saveNotCoreShareCategorysRels',
                        CoreCatId: item.ID,
                        CatIds: result.join(',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                        .then(function(data) {
                            $scope.data.relationItems[item.ID] = [];
                            getRelationCategory(item.ID);
                        });
                });
            };
        }
    ]);
